import type { AuthenticationStorage } from "@mirage/service-auth/types";
import LocalStorage from "@mirage/storage/local-storage";

// Pulled our from ./Storage.ts to remove a circular dependency.
// In general, storage should be accessed via the respective services but
// this is an exception in case the auth service is not initialized yet.
export const AUTH_STORAGE =
  LocalStorage<AuthenticationStorage>("authentication");
